module.exports = __webpack_public_path__ + "static/bart-141007697bd7bd29c6c08dcd86ef4048.svg";